import { useState } from 'react';
import { FacingMode } from 'consts';

interface IProps {
  isSelfie: boolean;
  videoRef: any;
}

export const useCameraStream = ({ isSelfie, videoRef }: IProps) => {
  const [mediaStream, setMediaStream] = useState<MediaStream | null>(null);

  const openCameraStream = async (settings?: Record<string, any>) => {
    const streamSettings = settings || {
      audio: false,
      video: { facingMode: isSelfie ? FacingMode.user : FacingMode.environment }
    };

    const stream = await navigator.mediaDevices.getUserMedia(streamSettings);
    if (videoRef?.current) videoRef.current.srcObject = stream;
    setMediaStream(stream);
  };

  const closeCameraStream = () => {
    if (mediaStream) {
      const tracks = mediaStream.getTracks();
      tracks.forEach(track => track.stop());
      setMediaStream(null);
    }
  };

  return { openCameraStream, closeCameraStream };
};
